/**
 * The admin consoles' API handle. The full partner / tenant / config / dlq CRUD
 * lives on the shared, session-aware data layer in {@link module:api/resources}.
 * This module is a thin hook that hands the consoles that `admin` slice, so
 * every call runs through the ONE app client (bearer token + 401-to-/login).
 */
import { useSession } from '../../auth/session';
import { DLQ_STAGES, type AdminApi, type DlqStage } from '../../api/resources';

export { DLQ_STAGES };
export type { AdminApi, DlqStage };

/** The admin API bound to the live session. */
export function useAdminApi(): AdminApi {
  return useSession().api.admin;
}
